// frontend/src/pages/root/router.tsx
import { RouterProvider } from "react-router-dom";
import { memo } from "react";
import { router } from "./index";
import { AuthProvider } from "../../context/AuthContext";
import { AuthInitializer } from "../../components/AuthInitializer";

const Root = memo(() => {
  return (
    <AuthProvider>
      <AuthInitializer>
        <RouterProvider router={router} />
      </AuthInitializer>
    </AuthProvider>
  );
});

export default Root;
